import React from 'react';
import {getReadableText, getSaturatedDark, hexToRgba, isLight} from '../../utils/ColorHelper';

export interface BandPillRecord {
  id?: string | number;
  label?: string;
  color?: string;
  displayOrder?: number | null;
}

interface BandPillProps {
  band?: BandPillRecord | null;
  dense?: boolean;
  showOrder?: boolean;
  showDot?: boolean;
  fallback?: string;
  tone?: 'subtle' | 'strong';
}

const FALLBACK_ACCENT = '#9fa9bd';

const BandPill: React.FC<BandPillProps> = ({
  band,
  dense = false,
  showOrder = true,
  showDot = true,
  fallback = '—',
  tone = 'subtle',
}) => {
  if (!band || (!band.label && !band.color)) {
    return <span className="gt-band-pill gt-band-pill-empty">{fallback}</span>;
  }
  const accent = band.color || FALLBACK_ACCENT;
  const strong = tone === 'strong';
  const light = isLight(accent);
  const className = `gt-band-pill${dense ? ' gt-band-pill-dense' : ''}${strong ? ' gt-band-pill-strong' : ''}`;
  return (
    <span
      className={className}
      style={{
        backgroundColor: hexToRgba(accent, strong ? 0.2 : 0.12),
        borderColor: strong ? (light ? hexToRgba(accent, 0.7) : accent) : hexToRgba(accent, 0.45),
        color: strong && !light ? accent : getReadableText(accent),
      }}
    >
      {showDot && (
        <span
          className="gt-band-pill-dot"
          style={{
            backgroundColor: accent,
            border: light ? `1px solid ${getSaturatedDark(accent)}` : undefined,
          }}
        />
      )}
      <span className="gt-band-pill-label">{band.label || '—'}</span>
      {showOrder && band.displayOrder != null && (
        <span className="gt-band-pill-order">#{band.displayOrder}</span>
      )}
    </span>
  );
};

export default BandPill;
